module.exports = __webpack_public_path__ + "static/img/s154.cd45d4b1.png";